module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isThemeLoading) ? _c('router-view') : _vm._e(), _vm._v(" "), (_vm.loading && !_vm.registrationState && !_vm.spinnerText) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('svg', {
    attrs: {
      "height": "38",
      "stroke": "#000",
      "viewBox": "0 0 38 38",
      "width": "38",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "stroke-width": "2",
      "transform": "translate(1 1)"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "18",
      "cy": "18",
      "r": "18",
      "stroke-opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36 18c0-9.94-8.06-18-18-18"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "dur": "1s",
      "from": "0 18 18",
      "repeatCount": "indefinite",
      "to": "360 18 18",
      "type": "rotate"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.registrationState) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('div', {
    staticClass: "ma2 mv4 bg-white mt5-ns mb6-ns ba b--light-gray br2 mw7 center-ns animated-slow slide-in",
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "flex pa3 flex-column justify-center items-center"
  }, [_c('p', {
    staticClass: "inter f6 pv3"
  }, [_vm._v(_vm._s(_vm.registrationError || 'Processing payment...'))]), _vm._v(" "), (!_vm.registrationError) ? _c('svg', {
    attrs: {
      "height": "38",
      "stroke": "#000",
      "viewBox": "0 0 38 38",
      "width": "38",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "stroke-width": "2",
      "transform": "translate(1 1)"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "18",
      "cy": "18",
      "r": "18",
      "stroke-opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36 18c0-9.94-8.06-18-18-18"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "dur": "1s",
      "from": "0 18 18",
      "repeatCount": "indefinite",
      "to": "360 18 18",
      "type": "rotate"
    }
  })], 1)])])]) : _vm._e()]), _vm._v(" "), (!!_vm.registrationError) ? _c('hr', {
    staticClass: "b--black-10"
  }) : _vm._e(), _vm._v(" "), (!!_vm.registrationError) ? _vm._t("modal-footer", function() {
    return [_c('div', {
      staticClass: "pa3 flex justify-end"
    }, [_c('ak-button', {
      attrs: {
        "newSecondary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.closeRegistrationErrorModal.apply(null, arguments)
        }
      }
    }, [_vm._v("Close")])], 1)]
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.spinnerText && _vm.loading) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('div', {
    staticClass: "ma2 mv4 bg-white mt5-ns mb6-ns ba b--light-gray br2 mw7 center-ns animated-slow slide-in",
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "flex pa3 flex-column justify-center items-center"
  }, [_c('p', {
    staticClass: "inter f6 pv3"
  }, [_vm._v(_vm._s(_vm.spinnerText))]), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "38",
      "stroke": "#000",
      "viewBox": "0 0 38 38",
      "width": "38",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "stroke-width": "2",
      "transform": "translate(1 1)"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "18",
      "cy": "18",
      "r": "18",
      "stroke-opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36 18c0-9.94-8.06-18-18-18"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "dur": "1s",
      "from": "0 18 18",
      "repeatCount": "indefinite",
      "to": "360 18 18",
      "type": "rotate"
    }
  })], 1)])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524462cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 471
// module chunks = 0